import { z } from 'zod';

import { Form } from '../../DataCollection/Form';

export const DataCollection = z.object({
  form: Form,
  /** How many columns to flow the form fields into when rendering. Defaults to 1. */
  columns: z.union([z.literal(1), z.literal(2)]).optional(),
});

export type DataCollection = z.infer<typeof DataCollection>;
